import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { BaIconChevronDown, BaIconChevronUp } from 'components/ui/icons';
import AnimateHeight from 'components/ui/animate-height';

import './styles.scss';

const CardSendControlCenterList = ({ listTitle, initialOpen, children }) => {
  const [toggled, setToggled] = useState(initialOpen);
  return (
    <div className="card-send-control-center-list-container">
      <div className="card-send-control-center-list-toggle" onClick={() => setToggled(!toggled)}>
        <span className="toggle-title">{listTitle}</span>
        <span className="toggle-icon">{toggled ? <BaIconChevronUp/> : <BaIconChevronDown/>}</span>
      </div>
      <AnimateHeight toggled={toggled}>
        <div className="card-send-control-center-list">
          {children}
        </div>
      </AnimateHeight>
    </div>
  );
}

CardSendControlCenterList.propTypes = {
  listTitle: PropTypes.string.isRequired,
  initialOpen: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default CardSendControlCenterList;
